import { AxiosResponse, AxiosError } from 'axios';
import { isNumber, isObject, isString } from './typeGuards';

/**
 * This is a collection of helpful typesafe type guards for `axios` library
 * See more on https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */

const hasResponseKeys = (v: unknown): v is { [P in keyof AxiosResponse]: unknown } => {
  const requiredKeys: (keyof AxiosResponse)[] = ['data', 'status', 'statusText', 'headers', 'config'];
  return isObject(v) && requiredKeys.every((key) => key in v);
};

export const isAxiosResponse = (v: unknown): v is AxiosResponse => {
  if (isObject(v) && hasResponseKeys(v)) {
    return isNumber(v.status) && isString(v.statusText) && isObject(v.config);
  }
  return false;
};

// TODO: isAxiosError is added into `axios` library itself starting from 0.21.3 (https://github.com/axios/axios/commit/f472e5da5fe76c72db703d6a0f5190e4ad31e642)
// but sinse we use the older version we need this
export const isAxiosError = (v: unknown): v is AxiosError => {
  return isObject(v) && 'isAxiosError' in v;
};
